"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ic_mail = void 0;
var ic_mail = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
    }
  }]
};
exports.ic_mail = ic_mail;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-icons-kit/md/ic_mail.js
// module id = 138
// module chunks = 0